export const SECTION_TYPES = [
  "hero",
  "text-block",
  "cards",
  "slider",
  "gallery",
  "video",
  "faq",
  "downloads",
  "contact-info",
  "articles",
  "projects",
  "positions",
  "culture",
  "cta",
  "contact-banner",
  "contact-info",
  "custom",
];

export const MEDIA_SECTION_TYPES = new Set([
  "hero",
  "text-block",
  "slider",
  "gallery",
  "video",
  "cta",
  "culture",
]);

export const MEDIA_FIELD_TYPES = new Set([
  "image",
  "video",
  "file",
  "gallery",
  "slider",
]);
